import { isFirefox, isSafari } from 'src/utils/browser.util';
import * as serviceWorker from '../serviceWorker';
import regionConfig from '../config';

interface NotificationResult {
    close: () => void;
}
export class NotificationManager {
    persistentNotifications: NotificationResult[] = [];

    static isSupported() {
        return 'Notification' in window;
    }

    static getPermission(): NotificationPermission {
        return this.isSupported() ? Notification.permission : 'denied';
    }

    static requestPermission(): Promise<NotificationPermission> {
        // if (isSafari()) {
        //     return new Promise((resolve) => {
        //         Notification.requestPermission((permission) => resolve(permission));
        //     });
        // }
        return Notification.requestPermission();
    }

    static getIcon() {
        return `${window.location.origin}${process.env.REACT_APP_NOTIFICATION_ICON_URL}`;
    }

    static createLocalNotification(title: string, body: string) {
        const notification = new Notification(title, {
            body,
            icon: this.getIcon(),
            requireInteraction: true,
        });

        notification.addEventListener('click', () => {
            notification.close();
        });
        return notification;
    }

    static createPersistentNotification(title: string, body: string): NotificationResult {
        if (isSafari() || isFirefox()) {
            const timeout = 5000;

            let timerId: any = null;
            let notification: Notification | null = null;

            const repeatNotification = () => {
                clearTimeout(timerId);
                notification?.close();
                notification = NotificationManager.createLocalNotification(title, body);
                notification.addEventListener('click', () => {
                    clearTimeout(timerId);
                    notification?.close();
                });
                timerId = setTimeout(repeatNotification, timeout);
            };

            repeatNotification();

            return {
                close: () => {
                    clearTimeout(timerId);
                    notification?.close();
                },
            };
        }

        const tag = `${Date.now()}`;
        serviceWorker.showNotification(title, {
            body,
            tag,
            icon: this.getIcon(),
            requireInteraction: true,
        });
        return {
            close: () => {
                serviceWorker.closeNotifications(tag);
            },
        };
    }

    showNotification(title: string, body: string, persist: boolean = false) {
        if (Notification.permission === 'denied') {
            return;
        }

        const signLivePrefixTitle = `${regionConfig.appName}: ${title}`;
        if (persist) {
            const result = NotificationManager.createPersistentNotification(
                signLivePrefixTitle,
                body,
            );
            this.persistentNotifications.push(result);
        } else {
            NotificationManager.createLocalNotification(signLivePrefixTitle, body);
        }
    }

    closeNotifications() {
        this.persistentNotifications.forEach((notification) => notification.close());
        this.persistentNotifications = [];
    }
}
